import { useState } from "react";
import { getAllMenu } from "@/service/menuAuth/menu";

export default () => {
    const [web, setWeb] = useState<any>(null);

    const getWebUser = async () => {
        const resp = await getAllMenu();
        if (resp?.code !== 200) return undefined;
        return resp?.data || undefined;
    };

    const refreshWebUser = async (callback?: () => void) => {
        const data = await getWebUser();
        if (data) {
            setWeb(data);
            callback?.();
        }
    };
    return {
        web,
        setWeb,
        getWebUser,
        refreshWebUser,
    };
};